import { red500, sand } from '@/theme/colors';

import Alert from '../Alert';
import Button from '../Button';
import Picture from '../Picture';
import s from './MemberRequest.module.scss';

function MemberRequest({ user, membersSet, onApprove, onDeny }: any) {
  return (
    <Alert preset="notification" backgroundColor={sand}>
      <div className={s.memberRequest}>
        <div>
          <Picture user={user} size={60} />
        </div>

        <div className={s.memberRequestContent}>
          <div className={s.memberRequestText}>
            {user.name} would like to join {membersSet}.
          </div>

          <Button size="small" onClick={onApprove}>
            Approve
          </Button>

          {/* ENG-5251: color="white" (not backgroundColor={white}) so the
              Button's `white` preset honors fontColor and renders theme-
              aware tokens (var(--surfaceCard) bg, var(--red500) text) in
              both light and dark modes. */}
          <Button
            size="small"
            color="white"
            fontColor={red500}
            style={{ marginLeft: 15 }}
            onClick={onDeny}
          >
            Deny
          </Button>
        </div>
      </div>
    </Alert>
  );
}

export default MemberRequest;
